// safetyAuditValidation.js
// Utility file to validate outgoing safety audit form information
// Validation should really only occur for safety audit forms that are submitted and not for any other type

const validateSafetyAuditChecklistEmployees = (employees) => {
  const errors = [];
  if (!employees || employees.length === 0) {
    errors.push("At least one employee is required");
  } else {
    employees.forEach((employee) => {
      if (!employee.employee_id || String(employee.employee_id).trim() === "") {
        errors.push({
          safetyAuditChecklistEmployeeRowId: employee.id,
          errors: {
            employeeId: "Employee is required or delete the row",
          },
        });
      }
    });
  }
  return errors;
};

export const validateSafetyAuditChecklist = (safetyAuditData) => {
  const errors = {};

  // Validating the audit date (using snake_case property from model)
  if (
    !safetyAuditData.audit_date ||
    String(safetyAuditData.audit_date).trim() === ""
  ) {
    errors.audit_date = "Audit Date is required";
  } else {
    // Validating the audit date is a valid date
    const yyyymmddRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
    if (!yyyymmddRegex.test(String(safetyAuditData.audit_date))) {
      errors.audit_date = "Invalid Audit Date";
    }
  }

  // Validating the audit time (using snake_case property from model)
  if (
    !safetyAuditData.audit_time ||
    String(safetyAuditData.audit_time).trim() === ""
  ) {
    errors.audit_time = "Audit Time is required";
  } else {
    // Validating the audit time is a valid time
    const auditTimeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    if (!auditTimeRegex.test(String(safetyAuditData.audit_time))) {
      errors.audit_time = "Invalid Audit Time";
    }
  }

  // Validating the project number (using snake_case property from model)
  if (
    !safetyAuditData.project_number ||
    String(safetyAuditData.project_number).trim() === ""
  ) {
    errors.project_number = "Project Number is required";
  }

  // Validating the supervisor (using snake_case property from model)
  if (
    !safetyAuditData.supervisor ||
    String(safetyAuditData.supervisor).trim() === ""
  ) {
    errors.supervisor = "Supervisor is required";
  }

  // Validating the scope of work (using snake_case property from model)
  if (
    !safetyAuditData.scope_of_work ||
    String(safetyAuditData.scope_of_work).trim() === ""
  ) {
    errors.scope_of_work = "Scope of Work is required";
  }

  // Validating Employees list
  const employeesErrors = validateSafetyAuditChecklistEmployees(
    safetyAuditData.employees
  );

  if (employeesErrors.length > 0) {
    errors.employees = employeesErrors;
  }

  // Returning both field errors (snake_case keys for form) and nice errors (formatted for notification)
  const niceErrors = {};
  if (errors.audit_date) niceErrors["Audit Date"] = errors.audit_date;
  if (errors.audit_time) niceErrors["Audit Time"] = errors.audit_time;
  if (errors.project_number)
    niceErrors["Project Number"] = errors.project_number;
  if (errors.supervisor) niceErrors["Supervisor"] = errors.supervisor;
  if (errors.scope_of_work) niceErrors["Scope of Work"] = errors.scope_of_work;
  if (errors.employees) niceErrors["Employees"] = errors.employees;

  return {
    fieldErrors: errors, // snake_case keys for form field display
    notificationErrors: niceErrors, // Nice formatted keys for notification modal
  };
};
